import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewIngresoInsumos = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'adm_stock',
        name: 'Ingreso de insumos',
        component: ViewIngresoInsumos,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
